import { Container } from 'react-bootstrap';
import {
  SectionHeadingMed,
  HeadingDesc,
  SubSectionHeading
} from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import img1 from '../../../assets/images/png/healthicon1.png';
import img2 from '../../../assets/images/png/healthicon2.png';
import img3 from '../../../assets/images/png/healthicon3.png';
import img4 from '../../../assets/images/png/healthicon4.png';
import img5 from '../../../assets/images/png/healthicon5.png';
import './healthConditions.css';

function HealthConditions() {
  return (
    <section className="section">
      <Container className="healthConditions">
        <div className="large box">
          <div>
            <SectionHeadingMed
              text="صحت اے سے زیڈ
"
            />
            <HeadingDesc
              text="عام اور پیچیدہ صحت کی بیماریوں اور حالات کے بارے میں مزید جانیں۔
"
            />
            <SimpleButton
              text="سب دیکھیں
"
            />
          </div>
        </div>
        <div className="medium box bg_tifannyblue">
          <SubSectionHeading
            text="کمر درد
"
            color="#FFFFFF"
          />
          <div className="box_img">
            <img src={img5} alt="" />
          </div>
        </div>
        <div className="large box bg_green">
          <SubSectionHeading
            text="چھاتی کا سرطان
"
            color="#FFFFFF"
          />
          <div className="box_img">
            <img src={img4} alt="" />
          </div>
        </div>
        <div className="large box bg_rosepink">
          <SubSectionHeading
            text="زبانی صحت
"
            color="#FFFFFF"
          />
          <div className="box_img">
            <img src={img2} alt="" />
          </div>
        </div>
        <div className="medium box bg_tifannyblue_light">
          <SubSectionHeading
            text="آٹزم
"
            color="#313131"
          />
          <div className="box_img">
            <img src={img3} alt="" />
          </div>
        </div>
        <div className="medium box bg_yellow">
          <SubSectionHeading
            text="ذیابیطس
"
            color="#313131"
          />
          <div className="box_img">
            <img src={img1} alt="" />
          </div>
        </div>
      </Container>
    </section>
  );
}

export default HealthConditions;
